import React from 'react';
import PageHero from '../components/PageHero';
import FoodPhilosophy from '../components/FoodPhilosophy';
import FoodServed from '../components/FoodServed';

const HealthyEating = () => {
    return (
        <>
            <PageHero title="Nutritious, home-cooked meals that help children grow and develop healthy habits." />
            <FoodPhilosophy />
            <FoodServed />
        </>
    );
};

export default HealthyEating;
